module.exports = __webpack_public_path__ + "static/media/white_girl.a8d8c434.jpeg";